module.exports = __webpack_public_path__ + "static/media/firstam_becky_allsbury.5d127d8b.jpg";